/* unplugin-vue-components disabled */import { render } from "./StepType.vue?vue&type=template&id=0af4ff33"
import script from "./StepType.vue?vue&type=script&lang=js"
export * from "./StepType.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__